"use strict";

exports.__esModule = true;
exports.UndoController = void 0;
var _react = require("react");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Controller for undo / redo and history.
 */
var UndoController = exports.UndoController = /*#__PURE__*/function (_Component) {
  function UndoController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      // eslint-disable-next-line react/no-unused-state
      state: _this.props.value,
      // eslint-disable-next-line react/no-unused-state
      index: 0,
      // eslint-disable-next-line react/no-unused-state
      history: [_this.props.value],
      // eslint-disable-next-line react/no-unused-state
      canUndo: false,
      // eslint-disable-next-line react/no-unused-state
      canRedo: false,
      // eslint-disable-next-line react/no-unused-state
      setState: function setState(newState) {
        _this.setState(function (_ref) {
          var state = _ref.state,
            history = _ref.history;
          var nextState = Object.assign({}, state, typeof newState === "function" ? newState(state) : newState);
          var nextHistory = history.concat(nextState);
          return {
            state: nextState,
            index: history.length,
            canUndo: true,
            canRedo: false,
            history: nextHistory
          };
        }, _this.fireOnChange);
      },
      // eslint-disable-next-line react/no-unused-state
      undo: function undo() {
        var onChange = _this.props.onChange;
        var _this$state = _this.state,
          history = _this$state.history,
          index = _this$state.index;
        if (index > 0) {
          var nextState = Object.assign({}, history[index - 1]);
          onChange(nextState);
          _this.setState({
            index: index - 1,
            // eslint-disable-next-line react/no-unused-state
            state: nextState,
            // eslint-disable-next-line react/no-unused-state
            canUndo: index > 1,
            // eslint-disable-next-line react/no-unused-state
            canRedo: true
          }, _this.fireOnChange);
        }
      },
      // eslint-disable-next-line react/no-unused-state
      redo: function redo() {
        var onChange = _this.props.onChange;
        var _this$state2 = _this.state,
          history = _this$state2.history,
          index = _this$state2.index;
        if (index < history.length - 1) {
          var nextState = Object.assign({}, history[index + 1]);
          onChange(nextState);
          _this.setState({
            index: index + 1,
            // eslint-disable-next-line react/no-unused-state
            state: nextState,
            // eslint-disable-next-line react/no-unused-state
            canUndo: true,
            // eslint-disable-next-line react/no-unused-state
            canRedo: index < history.length - 2
          }, _this.fireOnChange);
        }
      }
    };
    _this.fireOnChange = function () {
      var onChange = _this.props.onChange;
      var state = _this.state.state;
      onChange(state);
    };
    return _this;
  }
  _inheritsLoose(UndoController, _Component);
  var _proto = UndoController.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    return this.props.children(this.state);
  };
  return UndoController;
}(_react.Component);